import React from 'react';
import { FormField, Select } from '@cloudscape-design/components';

export const TrainingMetricsChartControls = ({
  firstMetricName,
  metricNamesOptions,
  setSelectedMetric,
  compareMetric,
  setCompareMetric,
  range,
  setRange,
  trainingName = 'Job',
}: {
  firstMetricName?: string;
  metricNamesOptions?: { name: string; value: string }[];
  setSelectedMetric: (metric: string) => void;
  compareMetric: string;
  setCompareMetric: (metric: string) => void;
  range: number;
  setRange: (range: number) => void;
  trainingName?: string;
}) => {
  return (
    <div className="metrics-graph__controls">
      <FormField label="Metric">
        <Select
          disabled={!metricNamesOptions}
          selectedOption={{ label: firstMetricName, value: firstMetricName }}
          placeholder="Select a metric to view"
          options={metricNamesOptions}
          onChange={(e) => {
            if (e.detail.selectedOption.value)
              setSelectedMetric(e.detail.selectedOption.value);
          }}
        />
      </FormField>
      <FormField label="Compare Metric">
        <Select
          disabled={!metricNamesOptions}
          placeholder="Select a metric to compare"
          options={metricNamesOptions}
          onChange={(e) => {
            if (e.detail.selectedOption.value)
              setCompareMetric(e.detail.selectedOption.value);
          }}
          selectedOption={
            compareMetric
              ? { label: compareMetric, value: compareMetric }
              : null
          }
        />
      </FormField>
      <FormField label={`${trainingName}s Shown`}>
        <Select
          disabled={!metricNamesOptions}
          selectedOption={
            range === 0
              ? { label: 'All jobs', value: range.toString() }
              : { label: range.toString(), value: range.toString() }
          }
          options={[
            {
              label: `10 most recent ${trainingName.toLowerCase()}s`,
              value: '10',
            },
            {
              label: `25 most recent ${trainingName.toLowerCase()}s`,
              value: '25',
            },
            {
              label: `50 most recent ${trainingName.toLowerCase()}s`,
              value: '50',
            },
            {
              label: `100 most recent ${trainingName.toLowerCase()}s`,
              value: '100',
            },
            { label: `All ${trainingName.toLowerCase()}s`, value: '0' }, // setRange(0) indicates all jobs
          ]}
          onChange={(e) => {
            if (e.detail.selectedOption.value)
              setRange(parseInt(e.detail.selectedOption.value));
          }}
        />
      </FormField>
    </div>
  );
};
